import { Component, Inject, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { formatDate } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { ApprovalDashBoardService } from 'src/app/services/approval-dashboard/approval-dashboard.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BillingAdjustmentStatusEnum, BillingAdjustmentStatusEnumDisplay, EmptyFallbackPipe, formatMoney, isNullOrEmptyOrWhitespace } from 'src/utilities';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-display-invoice-dialog',
    imports: [MatDialogModule, MatCardModule, MatExpansionModule, MatAccordion,
        MatTableModule,
        MatButtonModule,
        MatIconModule, MatTooltipModule,
        CommonModule, EmptyFallbackPipe],
    templateUrl: './display-invoice-dialog.component.html',
    styleUrls: ['./display-invoice-dialog.component.scss']
})
export class DisplayInvoiceDialogComponent {
  selectedData: any;
  panels: any[] = [];
  callFrom: any;
  isLoading:boolean = false;
  isGoodWillRequest: boolean = false;
  invoiceDataSource = new MatTableDataSource<InvoiceDetails>([]);

  invoiceDisplayedColumns = [
    { label: 'ADJ REQ ID#', propertyName: 'adjReqId' },
    { label: 'Customer Name', propertyName: 'customerName' },
    // { label: 'Creation Time', propertyName: 'recordCreationTimestamp' },
    { label: 'CMF', propertyName: 'cmf' },
    { label: 'MMS', propertyName: 'mms' },
    { label: 'WE Period', propertyName: 'wePeriod' },
    { label: 'Billing Site', propertyName: 'displayBillingSite' },
    { label: 'Orig Stmt', propertyName: 'origStmt' },
    { label: 'Invoice #', propertyName: 'invoiceNumber' },
    { label: 'Invoice Date', propertyName: 'invDate' },
    { label: 'PCS', propertyName: 'pcs' },
    { label: 'F25 Domestic Mail Current', propertyName: 'f25DomMail_Current' },
    { label: 'D49Fsc Current', propertyName: 'd49Fsc_Current' },
    { label: 'D90MinFee Current', propertyName: 'd90MinFee_Current' },
    { label: '99Misc Current', propertyName: '_99Misc_Current' },
    { label: 'F03Intl Current', propertyName: 'f03Intl_Current' },
    { label: 'Total Invoice', propertyName: 'totalInvoice' },
    { label: 'FSCRate Billed', propertyName: 'fscRateBilled' },
    { label: 'Correct FSC', propertyName: 'correctFSC' },
    { label: 'F25 Domestic Mail New', propertyName: 'f25DomMail_New' },
    { label: 'D49Fsc New', propertyName: 'd49Fsc_New' },
    { label: 'D90MinFee New', propertyName: 'd90MinFee_New' },
    { label: '99Misc New', propertyName: '_99Misc_New' },
    { label: 'F03Intl New', propertyName: 'f03Intl_New' },
    { label: 'Total Correct Charges', propertyName: 'totalCorrectCharges' },
    { label: 'F25 Domestic Mail Adj', propertyName: 'f25DomMail_Adj' },
    { label: 'D49Fsc Adj', propertyName: 'd49Fsc_Adj' },
    { label: 'D90MinFee Adj', propertyName: 'd90MinFee_Adj' },
    { label: '99Misc Adj', propertyName: '_99Misc_Adj' },
    { label: 'F03Intl Adj', propertyName: 'f03Intl_Adj' },
    { label: 'Total Adjustment', propertyName: 'totalAdjustment' },
    { label: 'Action', propertyName: 'action' },
    {label : 'AE', propertyName: 'ae'},
    {label : 'Requestor', propertyName: 'requestor'},
    {label : 'Requestor Status', propertyName: 'requestorStatus'},
    {label : 'MI Status', propertyName: 'status'},
    {label : 'Actioned By (MI)', propertyName: 'firstLevelApprover'},
    {label : 'MI Remarks', propertyName: 'firstLevelRemarks'},
    {label : 'MI Second Level Approver', propertyName: 'secondLevelApprover'},
    {label : 'MI Second Level Remarks', propertyName: 'secondLevelRemarks'},
    {label : 'GBS Status', propertyName: 'gbsStatus'},
    {label : 'Actioned By (GBS)', propertyName: 'gbsApprover'},
    {label : 'GBS Remarks', propertyName: 'gbsRemarks'}
  ];

  invoiceDisplayedGoodWillColumns = [
    { label: 'ADJ REQ ID#', propertyName: 'adjReqId' },
    { label: 'Customer Name', propertyName: 'customerName' },
    // { label: 'Creation Time', propertyName: 'recordCreationTimestamp' },
    { label: 'CMF', propertyName: 'cmf' },
    { label: 'MMS', propertyName: 'mms' },
    { label: 'Billing Site', propertyName: 'displayBillingSite' },
    { label: 'Invoice #', propertyName: 'invoiceNumber' },
    { label: 'Net Adjustment', propertyName: 'totalAdjustment' },
    { label: 'Action', propertyName: 'action' },
    { label: 'AE', propertyName: 'ae' },
    { label: 'Requestor', propertyName: 'requestor' },
     {label : 'Requestor Status', propertyName: 'requestorStatus'},
    { label: 'MI Status', propertyName: 'status' },
    { label: 'Actioned By (MI)', propertyName: 'firstLevelApprover' },
    { label: 'MI Remarks', propertyName: 'firstLevelRemarks' },
    {label : 'MI Second Level Approver', propertyName: 'secondLevelApprover'},
    {label : 'MI Second Level Remarks', propertyName: 'secondLevelRemarks'},
    { label: 'GBS Status', propertyName: 'gbsStatus' },
    { label: 'Actioned By (GBS)', propertyName: 'gbsApprover' },
    { label: 'GBS Remarks', propertyName: 'gbsRemarks' }
  ];

  invoiceDisplayedSummaryDetails = [
    { label: 'MMS#', propertyName: 'mms' },
    { label: 'CMF#', propertyName: 'cmf' },
    { label: 'Customer Name', propertyName: 'customerName' },
    { label: 'WE Period', propertyName: 'wePeriod' },
    { label: 'Billing Site', propertyName: 'displayBillingSite' },
    { label: 'Orig Stmt#', propertyName: 'origStmt' },
    { label: 'Invoice #', propertyName: 'invoiceNumber' },
    { label: 'Invoice Date', propertyName: 'invDate' },
    { label: 'Total Invoice', propertyName: 'totalInvoice' },
    { label: 'Total Correct Charges', propertyName: 'totalCorrectCharges' },
    { label: 'Net Adjustment', propertyName: 'totalAdjustment' },
    { label: 'Action', propertyName: 'action' },
    { label: 'AE', propertyName: 'ae' },
    { label: 'Requestor', propertyName: 'requestor' },
     {label : 'Requestor Status', propertyName: 'requestorStatus'},
    { label: 'MI Status', propertyName: 'status' },
    { label: 'Actioned By (MI)', propertyName: 'firstLevelApprover' },
    { label: 'MI Remarks', propertyName: 'firstLevelRemarks' },
    {label : 'MI Second Level Approver', propertyName: 'secondLevelApprover'},
    {label : 'MI Second Level Remarks', propertyName: 'secondLevelRemarks'},
    { label: 'GBS Status', propertyName: 'gbsStatus' },
    { label: 'Actioned By (GBS)', propertyName: 'gbsApprover' },
    { label: 'GBS Remarks', propertyName: 'gbsRemarks' }
  ];

  invoiceDisplayedColumnKeys = this.invoiceDisplayedColumns.map(c => c.propertyName);
  invoiceDisplayedColumnSummary = this.invoiceDisplayedSummaryDetails.map(c => c.propertyName);

  constructor(
    public dialogRef: MatDialogRef<DisplayInvoiceDialogComponent>,
    private approvalDashBoardService: ApprovalDashBoardService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedData = data.details;
    this.callFrom = data.callFrom;
  }

  ngOnInit(): void {
    if (this.selectedData) {
      this.loadInvoiceDetails();
    }
  }
  displayedColumnsList(): any[] {
    return this.isGoodWillRequest ? this.invoiceDisplayedGoodWillColumns : this.invoiceDisplayedColumns
  }

  displayedColumnsSummaryList(): any[] {

    return this.invoiceDisplayedSummaryDetails
  }

  loadInvoiceDetails() {
    if (this.selectedData.adjReason === "Goodwill" || this.selectedData.adjTypeDescription === "Goodwill") {
      this.isGoodWillRequest = true;
      this.invoiceDisplayedColumnKeys = this.invoiceDisplayedGoodWillColumns.map(c => c.propertyName);
    } else {
      this.isGoodWillRequest = false;
      this.invoiceDisplayedColumnKeys = this.invoiceDisplayedColumns.map(c => c.propertyName);
    }
    if (this.selectedData) {
      this.selectedData.adjSubId = isNullOrEmptyOrWhitespace(this.selectedData.adjSubId) ? 0 : this.selectedData.adjSubId;
      this.approvalDashBoardService.getInvoiceDetails(this.selectedData.adjReqId,this.selectedData.adjSubId,this.selectedData.detailsId).subscribe({
        next: response => {
          this.isLoading = true;
          this.panels = response.data || [];
          const notYetStatuses = [1,2,3,4,5,14,15,18,19,20];
          this.panels.forEach(x => {
            ['invDate', 'wePeriod', 'recordCreationTimestamp'].forEach(field => {
              if (x[field]) {
                x[field] = formatDate(x[field], 'MM/dd/yyyy', 'en-US');
              }
            const statusId = Number(x.statusId) as BillingAdjustmentStatusEnum;
            x.gbsStatus = x.isGBSNMF
              ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation]
              : notYetStatuses.includes(statusId)
                ? '--'
                : BillingAdjustmentStatusEnumDisplay[statusId];

            const gbsIsNMF = x.gbsStatus === 'GBS Need More Information';
            const isSubmitted = statusId === BillingAdjustmentStatusEnum.Submitted;
            x.requestorStatus = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.Submitted];
            if ((gbsIsNMF && !isSubmitted) || (x.gbsStatus !== '--' && !gbsIsNMF)) {
              x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
            } else if (statusId === BillingAdjustmentStatusEnum.Submitted || statusId === BillingAdjustmentStatusEnum.PRSSubmitted || statusId === BillingAdjustmentStatusEnum.Saved || statusId === BillingAdjustmentStatusEnum.Cancelled) {
              x.status = '--';
              x.requestorStatus = BillingAdjustmentStatusEnumDisplay[statusId] ?? '--';
            } else {
              x.status = BillingAdjustmentStatusEnumDisplay[statusId] ?? '--';
            }
             });
            const moneyFields = [
              'totalAdjustment', 'f25DomMail_Current', 'd49Fsc_Current', 'd90MinFee_Current', '_99Misc_Current',
              'f03Intl_Current', 'totalInvoice', 'f25DomMail_New', 'd49Fsc_New', 'd90MinFee_New',
              '_99Misc_New', 'f03Intl_New', 'totalCorrectCharges', 'f25DomMail_Adj', 'd49Fsc_Adj',
              'd90MinFee_Adj', '_99Misc_Adj', 'f03Intl_Adj'
            ];
            moneyFields.forEach(field => {
              if (x[field] !== undefined && x[field] !== null) {
                x[field] = formatMoney(x[field]);
              }
            })
            x.correctFSC = x.correctFSC + '%';
            x.fscRateBilled = x.fscRateBilled + '%'
          });
        },
        error: err => {
          console.error('Error fetching statement details:', err); // Debugging statement
          this.isLoading = true;
        }
      })
    }
  }

  closePopup() {
    this.dialogRef.close();
  }
  isNegative(value: any): boolean {
    if (typeof value === 'string') {
      const regex = /^\$\s?\(\d{1,3}(?:,\d{3})*(?:\.\d{2})?\)$/;
      return regex.test(value.trim());
    }
    return false;
  }
  
}


